// We can't use reflection here like:
//     const BASIC = FeatureGroup[FeatureGroup.basic];
// Because we have a FeatureGroup constant string union member, and
// FeatureGroup[FeatureGroup.basic] is not recognized as a constant string, but
// instead is a mutable string of any value.
//
// We also can't declare the enum as constant, as that prevents the
// FeatureGroup[FeatureGroup.basic] reflection entirely.
//
// In future, we'll look to replace these constants with references to the enum
// members, or the string union defined in ./types.ts
import type { FeatureGroup } from './types';

export const BASIC = 'basic';

export const PLUS = 'plus';

export const BUSINESS = 'business';

export const SCALE = 'scale';

export function parse(group: string | undefined): FeatureGroup | null {
  switch (group) {
    case 'basic':
      return BASIC;
    case 'plus':
      return PLUS;
    case 'business':
      return BUSINESS;
    case 'scale':
      return SCALE;
    default:
      return null;
  }
}
